import React from 'react';
import { StyledLabel, TableCellWithIcon } from '../../utils/tableCellCssUtils';

export enum BillsKeys {
  Bills = 'bills',
}

export const getBillStatusIcon = (status?: string): React.ReactNode => (
  <TableCellWithIcon>
    {/* There is no icon currently as statuses are not clearly defined at this point. */}
    {/* <NavigationAndActionWaitSmall /> */}
    <StyledLabel>{status}</StyledLabel>
  </TableCellWithIcon>
);
